import { t } from '../../i18n';
import { PairingStep } from './step/pairingStep.component';

export const makePatch = (count, patch) =>
  [...Array(count)]
    .map((_, i) => i)
    .reduce(
      (result, current) => ({
        ...result,
        [`Step${current}`]: patch,
      }),
      {},
    );

export const makeStepsTemplate = (count, style) => makePatch(count, { type: PairingStep, visible: false, ...style });

export const translate = (key, data) => {
  const result = t(key, data);

  return result === key ? null : result;
};

export const makeKeys = (base, count) => {
  const result = [];

  for (let i = 0; i < count; i += 1) {
    result.push(translate(`${base}${i + 1}`));
  }

  return result;
};

export const displaySteps = (steps, values) => {
  let digit = 0;

  steps.forEach((view, index) => {
    const text = values[index];

    view.title = text;
    view.digit = `0${digit + 1}`;
    view.visible = Boolean(text);

    if (view.visible) {
      digit += 1;
    }
  });
};

export const getSteps = (view, count, base = 'Step') =>
  [...Array(count)].map((_, index) => view.tag(`${base}${index}`)).filter(Boolean);
